export default __webpack_public_path__ + "static/media/marineabout.cd153bff.jpg";